export const reportPhishing = "I1Ry_";
export default {reportPhishing};